<template>
    <div class="CampaignFilter" :class="visible ? '--visible' : ''">
        <div class="CampaignFilter__platforms form-inline mb-5 pb-5 text-sm text-center">
            <CampaignFilterPlatformItem
                v-for="platform in platforms"
                :key="platform.id"
                :platform="platform"
                :filtered-platforms="filter.platforms"
                @change="setPlatform(platform, $event)"
            />
        </div>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.CampaignFilter {
    opacity: 0;
    transition: opacity 0.25s ease-in-out;

    &.--visible {
        opacity: 1;
    }
}

.CampaignFilter__platforms .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;

    &:not(:first-child) {
        margin-left: 30px;
    }
}
</style>

<script type="text/babel">
import CampaignFilterPlatformItem from 'dashboard-js/components/campaigns/CampaignFilterPlatformItem'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import collect from 'collect.js'

export default {
    components: { CampaignFilterPlatformItem },
    mixins: [RestoreOnPageBack],
    props: ['platforms', 'user', 'visible'],

    data() {
        return {
            filter: {
                platforms: [],
            },
        }
    },

    created() {
        this.onPageVisit(() => {
            // Set initial platforms
            Object.assign(
                this.filter.platforms,
                this.user.channels.length
                    ? collect(this.user.channels)
                          .pluck('platform_id')
                          .unique()
                          .toArray()
                    : collect(this.platforms)
                          .pluck('id')
                          .toArray()
            )

            // We won't signal 'ready' on restoration
            this.$emit('ready', this.filter)
        })
    },

    methods: {
        changed: _.debounce(function() {
            this.$emit('change', this.filter)
            this.saveState()
        }, 200),

        setPlatform(platform, checked) {
            checked
                ? this.filter.platforms.push(platform.id)
                : this.filter.platforms.splice(this.filter.platforms.indexOf(platform.id), 1)

            this.changed()
        },
    },
}
</script>
